import PhoneNumberConstructor from '@/views/modules/_common/phone-number.constructor';
import enums from '@/enums';

/**
 * Create a new caller id
 * @class CallerIdConstructor
 */
export default class CallerIdConstructor extends PhoneNumberConstructor {
  name = '';

  status = enums.Sender.Status.UNVERIFIED;

  type = enums.Sender.Caller.Type.PHONE_NUMBER;

  constructor(operation = enums.Operation.CREATE, payload = null, nameToCreate = '') {
    super(operation, payload);

    this.name = operation === enums.Operation.CREATE || !payload ? nameToCreate || '' : payload.name || '';

    this.type = operation === enums.Operation.CREATE || !payload
      ? enums.Sender.Caller.Type.PHONE_NUMBER
      : payload.type || enums.Sender.Status.UNVERIFIED;

    this.status = operation === enums.Operation.CREATE || !payload
      ? enums.Sender.Status.UNVERIFIED
      : payload.status || enums.Sender.Status.UNVERIFIED;
  }

  toCreatePayload() {
    return {
      name: this.name,
      ...super.toCreatePayload(),
    };
  }

  toEditPayload() {
    return {
      id: this.payload.id,
      name: this.name,
    };
  }
}
